<template>
  <BaseVeeForm :action="submit" ensure-error-keys-camel-case v-slot="formProps" class="space-y-8">
    <VModal ref="modal" @modal:hidden="$emit('hide')" :disable-backdrop-click="formProps.isPending">
      <div class="mx-auto bg-white rounded-lg text-left shadow-xl max-w-lg w-full">
        <div class="flex flex-col">
          <div class="flex-none px-4 py-4 sm:px-6 border-b border-gray-200">
            <div class="flex justify-between items-center">
              <div class="flex-1">Add Project</div>
              <div class="flex-none">
                <button
                  type="button"
                  class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="close"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="inline-flex h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="flex-1 px-4 pt-4 pb-4 sm:pb-6 sm:px-6">
            <div class="space-y-8">
              <div class="space-y-4">
                <ValidationProvider name="project" slim vid="projectId" rules="required">
                  <template #default="{ errors }">
                    <BaseFormGroup>
                      <BaseFormLabel> Project </BaseFormLabel>
                      <VSelect
                        v-model="formData.projectId"
                        :options="projectOptions"
                        label="name"
                        :reduce="(project) => project.uuid"
                        :filterable="false"
                        :disabled="formProps.isPending"
                        @search="onProjectSearch"
                        class="vue-select custom-option"
                      >
                        <template #option="{ name }">
                          <div class="flex group px-4 py-2 items-center">
                            <p class="text-sm font-medium text-gray-900 group-hover:text-white">
                              {{ name }}
                            </p>
                          </div>
                        </template>
                      </VSelect>
                      <BaseFormInlineMessage v-if="errors.length" danger>
                        {{ errors[0] }}
                      </BaseFormInlineMessage>
                    </BaseFormGroup>
                  </template>
                </ValidationProvider>
              </div>
              <div class="flex space-x-2">
                <BaseButton primary :disabled="formProps.invalid || formProps.isPending">
                  Save
                </BaseButton>
                <BaseButton
                  type="button"
                  primary
                  outline
                  :disabled="formProps.isPending"
                  @click="close"
                >
                  Cancel
                </BaseButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </VModal>
  </BaseVeeForm>
</template>

<script>
import { debounce } from 'lodash-es';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import { projectsClient } from '@/api/clients';

export default {
  name: 'ProductAddModal',
  props: {
    action: {
      type: Function,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        projectId: null,
      },
      projectOptions: [],
    };
  },
  created() {
    this.fetchProjects();
  },
  methods: {
    close() {
      this.$refs.modal.close();
    },
    async onProjectSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.searchProducts(loading, search, this);
      }
    },
    searchProducts: debounce(async (loading, search, vm) => {
      try {
        await vm.fetchProjects({
          filter: {
            search,
          },
        });
      } catch (error) {
        //
      } finally {
        loading(false);
      }
    }, 500),
    async fetchProjects(query = {}) {
      try {
        const response = await projectsClient.list({ params: query });

        this.setProjectOptions(response.data.data.map(mapKeysToCamelCase));

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    setProjectOptions(projects) {
      this.projectOptions = projects;
    },
    async submit() {
      try {
        await this.action(this.formData);

        this.close();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
